import _toConsumableArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var states = {
  visitedViews: [],
  cachedViews: []
};
var mutations = {
  DEL_VISITED_VIEW: function DEL_VISITED_VIEW(state, view) {
    if (state.cachedViews.includes(view.name)) return;
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name);
    }

    // 设置嵌入iframe
    if (state.visitedViews.some(function (v) {
      return v.path === view.fullPath;
    })) return;
    state.visitedViews.push({
      name: view.name,
      path: view.fullPath,
      title: view.meta.title || 'no-name'
    });
  },
  DEL_ALL_CACHED_VIEWS: function DEL_ALL_CACHED_VIEWS(state) {
    state.cachedViews = [];
  }
};
var actions = {
  delAllViews: function delAllViews(_ref, view) {
    var dispatch = _ref.dispatch,
      state = _ref.state;
    return new Promise(function (resolve) {
      dispatch('delAllVisitedViews', view);
      dispatch('delAllCachedViews', view);
      resolve({
        visitedViews: _toConsumableArray(state.visitedViews),
        cachedViews: _toConsumableArray(state.cachedViews)
      });
    });
  },
  delVisitedView: function delVisitedView(_ref2, view) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve) {
      commit('DEL_VISITED_VIEW', view);
      resolve(_toConsumableArray(state.visitedViews));
    });
  },
  delAllCachedViews: function delAllCachedViews(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve) {
      commit('DEL_ALL_CACHED_VIEWS');
      resolve(_toConsumableArray(state.cachedViews));
    });
  }
};
export default {
  namespaced: true,
  state: states,
  mutations: mutations,
  actions: actions
};